"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionDetail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const ton3_1 = require("ton3");
const ton_1 = require("ton");
const modal_1 = require("../../../components/ui/modal");
const detail_transaction_1 = require("../../../components/detail-transaction");
const tonapi_1 = require("../../../logic/tonapi");
const transaction_detail_module_css_1 = __importDefault(require("./transaction-detail.module.css"));
const TransactionDetail = ({ setShowTransactionDetail, showTransactionDetail, transDetail, setTransDetail, isTg, onClickBack, isModal = true }) => {
    const TgObj = sdk_1.default;
    const tonapi = new tonapi_1.TonApi();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [localAddres, setLocalAddres] = (0, react_1.useState)(transDetail?.address);
    const modalContentRef = (0, react_1.useRef)(null);
    const LocalAddresListener = async (address) => {
        if (address && address.endsWith('.ton')) {
            const res = await tonapi.getAddressByDomainName(address);
            if (!res || res?.wallet.address.length === 0) {
                return address;
            }
            const parsedAddres = ton_1.Address.parse(res?.wallet.address);
            setLocalAddres(String(parsedAddres));
        }
        else {
            setLocalAddres(address);
        }
    };
    (0, react_1.useEffect)(() => {
        LocalAddresListener(transDetail?.address);
    }, [transDetail?.address]);
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        setTransDetail(undefined);
        setShowTransactionDetail(false);
        window.document.body.style.overflow = 'auto';
        TgObj.MainButton.hide();
    };
    const handleBtnClick = () => {
        console.log('TRANS DETAIL');
        // window.open(`https://tonviewer.com/${localAddres}/transaction/${transDetail?.hash}`, '_blank')
        TgObj.openLink(`https://tonviewer.com/${localAddres}/transaction/${transDetail?.hash}`);
    };
    (0, react_1.useEffect)(() => {
        if (showTransactionDetail) {
            window.document.body.style.overflow = 'hidden';
        }
        return () => {
            window.document.body.style.overflow = 'auto';
        };
    }, [showTransactionDetail]);
    function enableBtn() {
        TgObj.MainButton.text = t('trans-detail.view-btn');
        if (ton3_1.Address.isValid(localAddres) && isTg) {
            TgObj.MainButton.show();
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
        }
        else {
            TgObj.MainButton.hide();
            TgObj.MainButton.disable();
        }
    }
    (0, react_1.useEffect)(() => {
        enableBtn();
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [showTransactionDetail, transDetail, localAddres]);
    (0, react_1.useEffect)(() => {
        if (!isModal) {
            setShowTransactionDetail(false);
            window.document.body.style.overflowY = 'hidden';
        }
    }, [isModal, showTransactionDetail]);
    const handleButtonClick = () => {
        handleCloseModal();
        if (onClickBack) {
            onClickBack();
        }
    };
    const handleScrollToPosition = () => {
        if (modalContentRef.current) {
            modalContentRef.current.scrollTop = 0;
        }
    };
    (0, react_1.useEffect)(() => {
        handleScrollToPosition();
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isModal ? ((0, jsx_runtime_1.jsx)("div", { className: transaction_detail_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsxs)(modal_1.Modal, { isOpen: showTransactionDetail, onClose: handleCloseModal, isCloseButton: false, className: `${transaction_detail_module_css_1.default.modal}`, children: [(0, jsx_runtime_1.jsx)("div", { className: transaction_detail_module_css_1.default.modalTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: transaction_detail_module_css_1.default.modalTopButton, onClick: handleCloseModal, children: t('common.close') }) }), (0, jsx_runtime_1.jsx)(detail_transaction_1.DetailTransaction, { status: transDetail?.status ?? '', amount: transDetail?.amount, date: transDetail?.date, address: transDetail?.address ?? '', fee: transDetail?.fee, hash: transDetail?.hash ?? '', token: transDetail?.token, detail: transDetail?.detail, localAddres: localAddres ?? '', color: transDetail?.color ?? 1, handleBtnClick: handleBtnClick, isTg: isTg })] }) })) : ((0, jsx_runtime_1.jsxs)("div", { className: transaction_detail_module_css_1.default.inner, ref: modalContentRef, children: [(0, jsx_runtime_1.jsx)("div", { className: transaction_detail_module_css_1.default.modalTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: transaction_detail_module_css_1.default.modalTopButton, onClick: handleButtonClick, children: t('common.close') }) }), (0, jsx_runtime_1.jsx)(detail_transaction_1.DetailTransaction, { status: transDetail?.status ?? '', amount: transDetail?.amount, date: transDetail?.date, address: transDetail?.address ?? '', fee: transDetail?.fee, hash: transDetail?.hash ?? '', token: transDetail?.token, detail: transDetail?.detail, color: transDetail?.color ?? 1, localAddres: localAddres ?? '', handleBtnClick: handleBtnClick, isTg: isTg })] })) }));
};
exports.TransactionDetail = TransactionDetail;
